import React, { FC, useCallback } from 'react';

import PropTypes from 'prop-types';

import Button from '@adsk/alloy-react-button';
import { CheckmarkIcon, XIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

import useInlineInput from './useInlineInput';

type EditButtonGroupProps = Pick<
  ReturnType<typeof useInlineInput>,
  'handleCancel' | 'handleSubmit' | 'modified'
> & {
  error?: boolean;
};

const preventOnBlur = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
  e.preventDefault();
};
/**
 * A Button Group for the edit mode of InlineEdit
 */
const EditButtonGroup: FC<EditButtonGroupProps> = ({
  handleCancel,
  handleSubmit,
  modified,
  error = false,
}) => (
  <>
    <Button
      onClick={handleCancel}
      onMouseDown={preventOnBlur}
      renderIcon={useCallback(
        (p) => (
          <XIcon {...p} />
        ),
        [],
      )}
      size={Button.SIZES.SMALL}
      style={{
        svg: {
          color: theme.colors.adskBlue700,
        },
        height: 24,
        margin: `0 ${theme.spacing.xxSmall}px`,
        width: 24,
      }}
    />
    <Button
      onClick={handleSubmit}
      onMouseDown={preventOnBlur}
      renderIcon={useCallback(
        (p) => (
          <CheckmarkIcon {...p} />
        ),
        [],
      )}
      size={Button.SIZES.SMALL}
      disabled={error}
      style={{
        height: 24,
        width: 24,
        ...(!modified &&
          !error && {
            svg: {
              color: theme.colors.adskBlue700,
            },
          }),
      }}
      variant={
        modified || error ? Button.VARIANTS.PRIMARY : Button.VARIANTS.SECONDARY
      }
    />
  </>
);

EditButtonGroup.displayName = 'EditButtonGroup';

EditButtonGroup.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  modified: PropTypes.bool.isRequired,
  error: PropTypes.bool,
};
export default EditButtonGroup;
